var highlight_row = window.highlight_row;
var highlight_row;
highlight_row = function (row) {
  var all_rows;
  all_rows = row.parents("*[data-hover-menu]").find(".hover_menu_row");
  all_rows.removeClass("hovered");
  return row.addClass("hovered");
};
$(document).on("mouseenter", "*[data-hover-menu]", function () {
  var element;
  element = $(e.currentTarget);
  element.data("hover-menu-on", true);
  return element.find(".hover_menu").fadeIn(100);
});
$(document).on("mouseleave", "*[data-hover-menu]", function () {
  var element;
  element = $(e.currentTarget);
  element.data("hover-menu-on", false);
  return _.delay(function () {
    if (!element.data("hover-menu-on")) {
      return element.find(".hover_menu").fadeOut(100);
    }
  }, 200);
});
$(document).on("mouseenter", "*[data-hover-menu=first]", function (e) {
  var immediate_target;
  immediate_target = $(e.target);
  if (!(immediate_target.is(".hover_menu") || immediate_target.parents().is(".hover_menu"))) {
    return highlight_row($($(e.currentTarget).find(".hover_menu_row").get(0)));
  }
});
$(document).on("mouseenter", "*[data-hover-menu] .hover_menu_row", function (e) {
  return highlight_row($(e.currentTarget));
});
window.highlight_row = highlight_row;